import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import $ from 'jquery'
import '../src/styles/font.css'
import "./utils/kiaBuriedPoint";
import 'swiper/css/swiper.css';
// import Vconsole from "vconsole";
// let vconsole = new Vconsole();

// Fix EventEmitter memory leak warning
import { EventEmitter } from 'events';
EventEmitter.defaultMaxListeners = 20;

// Global error handler to catch unhandled errors
window.addEventListener('error', function(event) {
  console.error('Global error caught:', event.error);
  // Prevent the error from being logged to console again
  event.preventDefault();
});

window.addEventListener('unhandledrejection', function(event) {
  console.error('Unhandled promise rejection:', event.reason);
  // Prevent the error from being logged to console again
  event.preventDefault();
});

import axios from "axios";
const instance = axios.create({});

// 添加请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 断网提示
    if (!navigator.onLine) {
      // Toast('网络异常，请检查网络');
    }
    console.log("%c config", "font-size:25px;color:green;", config);
    config.headers = {
      ...config.headers,
      "X-Fontre-Auth-Model": "token",
      "X-Fontre-Auth-Access": sessionStorage.getItem("kia_token") || "",
    };
    return config;
  },
  (error) => {
    console.log("请求拦截error", error);
    return Promise.reject(error);
  }
);

Vue.prototype.$axios = instance;
Vue.config.productionTip = false

// Vue error handler
Vue.config.errorHandler = function (err, vm, info) {
  console.error('Vue error caught:', err, info);
  // You can also send this to an error reporting service
}

Vue.use(ElementUI);

import { message } from './utils/resetMessage';
Vue.prototype.$message = message;
import NavBar from '@/components/NavBar'
Vue.component('NavBar',NavBar)
import Footer from '@/components/Footer'
Vue.component('Footer',Footer)

import 'animate.css/animate.min.css';

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
